
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookkeeping",
      function () {
        return require("private-next-pages/bookkeeping/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookkeeping"])
      });
    }
  